// extracted by mini-css-extract-plugin
export default {"textSmall":"Generics_textSmall__E6vGq","textMedium":"Generics_textMedium__oB+Kj","textLarge":"Generics_textLarge__HAHDa","btn":"Generics_btn__BI70Y"};